import React, { useEffect, useState } from 'react';
import { MDBFooter } from 'mdb-react-ui-kit';
import Ssl from '../../assets/ssl.png';

const iframe = '<iframe id="TL_iFrame_id_6641_2015_1628718357" src="https://app.trustlock.co/iframe/with/hover/6641/my-badge/2015" frameborder="0" vspace="0" hspace="0" scrolling="no" style="width: -webkit-fill-available"></iframe>';

export function Iframe(props) {
  return (<div dangerouslySetInnerHTML={{ __html: props.iframe ? props.iframe : "" }} />);
}


export default function Footer({ flag }) {
  const [show_text, set_show_text] = useState(false)
  useEffect(() => {
    if (sessionStorage.getItem('is_white_label')) {
      if (sessionStorage.getItem('is_white_label') !== "true") {
        set_show_text(true)
      } else {
        set_show_text(false)
      }
    }
  }, [flag])
  return (
    <MDBFooter backgroundcolor='light' className='text-center text-lg-left footer-area'>
      {show_text === true ? <><div className='text-center p-1 text-light' style={{ backgroundcolor: 'rgba(0, 0, 0, 0.2)' }} data-lang-str="footer"></div>
        <a name="trustbadge" href="https:/" ><img name="trustseal" alt="Trust Badges" style={{ border: "none", marginLeft: "1em" }} src={Ssl} width="210" height="40" /></a></> :
        <a name="trustbadge" href="https:/" ><img name="trustseal" alt="Trust Badges" style={{ border: "none" }} src={Ssl} width="210" height="40" /></a>}

    </MDBFooter>
  );
}